export const appSettingsTestUserLogs = "/app_settings/test_user_logs";
